
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabsforpuneairport() {



    const cardData =
    {
        keyword: 'Innova Crysta Cabs for Pune Airport',
        heading: 'Meghana Cab : Innova Crysta Cabs for Pune Airport',
        headingDescription: 'Meghana Cab offers Innova Crysta Cabs for Pune Airport, providing a premium and hassle-free airport transfer experience for both arrivals and departures. Whether you are flying in for business meetings or jetting off for leisure, our spacious Innova Crysta vehicles ensure comfort and convenience during your transit. Enjoy plush leather interiors, generous legroom, and ample luggage space for a smooth ride to and from Pune Airport. With prompt pickups, professional chauffeurs waiting with a name board, automatic flight status tracking, transparent fares, and 24/7 customer support, we guarantee timely pickups even in case of flight delays. Book your Innova Crysta Cab for Pune Airport with Meghana Cab and travel with peace of mind, style, and reliability.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada was once the epicenter of Maratha political power. Though much of it was destroyed in an 1828 fire, its majestic Delhi Gate, fortified stone walls, and expansive garden courtyards still attract thousands of visitors. The fort is enveloped in fascinating legends and haunted folklore, making it both a historical and mysterious destination. The evening light-and-sound show narrates Pune’s rich Maratha past and offers an immersive cultural experience."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 by Sultan Aga Khan III, this majestic palace served as a place of internment for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during India’s freedom struggle. Set amidst sprawling lawns, the palace features Italian arches, colonial architecture, and museums displaying Gandhi's personal items, letters, and photographs. It is both a serene retreat and an essential historical landmark that pays homage to India's journey toward independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km from Pune on a hilltop, Sinhagad Fort is a historic bastion that witnessed the valor of Tanaji Malusare in the Battle of Sinhagad (1670). The rugged trek up to the fort is rewarded with panoramic views of the Sahyadri ranges, crumbling bastions, and rustic food stalls serving traditional Maharashtrian fare. Popular among trekkers, photographers, and history enthusiasts, the fort is especially vibrant during monsoon and winter weekends."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut cave temple in the heart of Pune, Pataleshwar is dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features a sanctum with a lingam, a circular Nandi mandapa, and intricately carved pillars. The temple’s quiet ambiance offers a spiritual and architectural oasis amidst Pune’s bustling Jangli Maharaj Road. It stands as a testimony to the city’s ancient and sacred heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in the upscale Koregaon Park, the Osho Ashram is a global spiritual hub where meditation meets luxury. Spread over 28 acres of lush gardens, marble walkways, and tranquil Zen zones, it offers a range of spiritual and wellness programs—from dynamic meditation to healing therapies and personal growth workshops. The resort attracts international visitors seeking peace, rejuvenation, and mindfulness in a serene setting."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Home to over 20,000 artifacts collected by Dr. Dinkar Kelkar, this museum offers a fascinating glimpse into India’s everyday life from past centuries. It houses musical instruments, war weapons, antique vessels, traditional clothing, and beautifully carved doors. The highlight is the recreated ‘Mastani Mahal’, which reflects Maratha royalty and architecture. With audio guides and interactive exhibits, it appeals to both scholars and casual tourists alike."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill offers some of the best panoramic views of Pune. Visitors climb 103 steps to reach the summit, where they find 18th-century Peshwa-era temples dedicated to deities like Parvati, Ganesha, and Vishnu. A small museum and well-maintained gardens enhance the hill’s charm, making it ideal for early morning treks, photography, and spiritual reflection."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganapati is famous for its towering, gold-adorned idol of Lord Ganesha. With a history of over 125 years, the temple sees an influx of devotees year-round and becomes the focal point of Pune’s grand Ganesh Chaturthi celebrations. Located in Budhwar Peth, its spiritually charged atmosphere, devotional music, and vibrant décor offer a divine experience for visitors and worshippers alike."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Sprawled across 130 acres on the outskirts of Pune, this zoological park combines a modern zoo, snake park, lake, and nature trails. It is home to a wide variety of animals including tigers, elephants, sloth bears, and reptiles. Educational programs, picnic areas, and conservation efforts make it a favorite among families and school groups. The nearby Katraj Lake adds a scenic element to the wildlife experience."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Located in Wanowrie, Shinde Chhatri is a beautifully carved memorial dedicated to Maratha warrior Mahadji Shinde. Featuring Rajasthani-style domes, colorful glass panels, and detailed stone carvings, the structure reflects both Mughal and Rajput architectural influences. The peaceful ambiance and historical significance make it an underrated gem for history buffs and architecture lovers visiting Pune."
  }
],

"services": [
  {
    "name": "Innova Crysta Airport Taxi Pune",
    "description": "Experience hassle-free and comfortable airport transfers with our Innova Crysta airport taxi service in Pune. Perfect for solo travelers, families, and corporate clients, our spacious SUVs provide ample luggage space and a smooth ride to and from Pune Airport."
  },
  {
    "name": "Pune Airport Innova Crysta Cab Booking",
    "description": "Book your Pune airport Innova Crysta cab easily online or via phone. Our prompt and reliable service ensures timely pickups and drop-offs with professional chauffeurs dedicated to making your airport travel stress-free and convenient."
  },
  {
    "name": "AC Innova Crysta Pune Airport Transfer",
    "description": "Stay cool and comfortable during your airport transfer with our fully air-conditioned Innova Crysta cabs. Ideal for hot weather, our vehicles ensure a pleasant ride whether you’re heading to or from Pune Airport, with premium interiors and climate control."
  },
  {
    "name": "Online Booking Innova Crysta Taxi Pune Airport",
    "description": "Secure your Innova Crysta taxi for Pune airport transfers quickly with our user-friendly online booking platform. Enjoy instant confirmation, flexible scheduling, and transparent pricing for all your airport travel needs."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune Airport",
    "description": "Relax and leave the driving to our professional chauffeurs with our chauffeur-driven Innova Crysta airport service. We prioritize punctuality, safety, and courteous service to ensure your airport journey is smooth and comfortable."
  },
  {
    "name": "Family Airport Innova Crysta Taxi Pune",
    "description": "Travel with your family to or from Pune airport in a spacious and comfortable Innova Crysta taxi. With plenty of room for luggage and passengers, this service is ideal for hassle-free airport transfers with children and elders."
  },
  {
    "name": "Airport Pickup Innova Crysta Pune",
    "description": "Make your arrival at Pune airport stress-free with our prompt Innova Crysta pickup service. Our chauffeurs track your flight timings and wait for you, ensuring a smooth transition from the airport to your destination."
  },
  {
    "name": "Budget Innova Crysta Airport Cab Pune",
    "description": "Enjoy the luxury of an Innova Crysta airport cab in Pune without stretching your budget. Our competitively priced airport transfer services combine comfort and affordability, making premium travel accessible to all."
  },
  {
    "name": "Private Innova Crysta Pune Airport Ride",
    "description": "Opt for our private Innova Crysta airport rides in Pune for exclusive, personalized service. Perfect for VIPs and travelers seeking privacy and convenience, this service ensures dedicated vehicles and chauffeurs tailored to your schedule."
  }
],
"tableData": [
  ["Innova Crysta Airport Taxi Pune", "Pune Airport Innova Crysta Cab Booking"],
  ["AC Innova Crysta Pune Airport Transfer", "Online Booking Innova Crysta Taxi Pune Airport"],
  ["Chauffeur Driven Innova Crysta Pune Airport", "Family Airport Innova Crysta Taxi Pune"],
  ["Airport Pickup Innova Crysta Pune", "Budget Innova Crysta Airport Cab Pune"],
  ["Private Innova Crysta Pune Airport Ride", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Innova Crysta Cabs for Pune Airport Transfers",
        "WhyChoosedescription": "Experience smooth and timely transfers to and from Pune Airport with our premium Innova Crysta cabs. Perfect for business travelers, families, and groups, our service ensures you never miss your flight and travel in comfort."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Interiors",
        "WhyChoosedescription": "Our Innova Crysta cabs offer ample space for passengers and luggage, ergonomic seating, and air-conditioning, making your airport journey relaxing and stress-free, whether you’re traveling alone or with a group."
    },
    {
        "WhyChooseheading": "Professional Drivers with Airport Route Expertise",
        "WhyChoosedescription": "Our experienced drivers are familiar with Pune Airport’s pickup and drop-off points, flight schedules, and the fastest routes, ensuring punctuality and a hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Each Innova Crysta is regularly serviced and thoroughly sanitized before every trip, guaranteeing a safe and hygienic environment for your airport transfers."
    },
    {
        "WhyChooseheading": "Flexible Booking and Real-Time Updates",
        "WhyChoosedescription": "Book your Pune Airport cab in advance or on short notice with ease. Receive real-time updates on your driver’s arrival and flight status to stay informed throughout your journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy competitive and all-inclusive pricing that covers tolls, taxes, driver allowances, and fuel, providing complete peace of mind for your airport cab bookings."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Airport Transfers",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, changes, or special requests, ensuring your airport transfer is seamless and stress-free."
    },
    {
        "WhyChooseheading": "Ideal for Business Travelers and Family Groups",
        "WhyChoosedescription": "Whether you’re traveling for work or leisure, our Innova Crysta cabs cater to your needs with comfort, reliability, and professionalism, making your airport commute pleasant and convenient."
    }
]


















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab for Pune Airport?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and hassle-free booking."
    },
    {
        question: "Is Innova Crysta available for both airport pickup and drop services?",
        answer: "Yes, we offer both pickup and drop services to and from Pune Airport with Innova Crysta cabs."
    },
    {
        question: "Is Innova Crysta suitable for airport transfers with luggage?",
        answer: "Absolutely. Innova Crysta offers ample space for 6-7 passengers and their luggage, making it ideal for airport transfers."
    },
    {
        question: "Can I schedule a cab in advance for airport travel?",
        answer: "Yes, you can pre-book your Innova Crysta for airport travel to avoid last-minute stress."
    },
    {
        question: "Is the service available 24/7 for Pune Airport transfers?",
        answer: "Yes, we provide round-the-clock Innova Crysta cab service for Pune Airport."
    },
    {
        question: "Are the cabs sanitized before airport transfers?",
        answer: "Yes, all our vehicles are thoroughly cleaned and sanitized before each trip to ensure your safety."
    },
    {
        question: "Will the driver assist with luggage at the airport?",
        answer: "Yes, our professional drivers are courteous and will assist you with your luggage."
    },
    {
        question: "What are the payment options for airport cab booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I find my cab at the airport?",
        answer: "Your driver will coordinate via call and may hold a placard with your name at the pickup point if needed."
    },
    {
        question: "Is there a cancellation policy for airport cab bookings?",
        answer: "Yes, we offer flexible cancellation policies. Please contact us for details when booking."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Aniket Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta to Pune Airport for my family. On-time arrival, spacious car, and polite driver. Great experience!”',
    },
    {
        name: 'Ms. Rina Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and reliable airport drop in a well-maintained Innova Crysta. Highly recommend Meghana Cab.”',
    },
];








































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const airportCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Airport Taxi Service Pune",
  "description": "Book AC Innova Crysta cabs for Pune Airport transfers. Chauffeur driven, comfortable, and budget-friendly airport rides. Easy online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Airport Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-airport-innova-crysta-cab"
  }
};








    return (
        <div>



<Helmet>
  <title>Innova Crysta Cabs for Pune Airport | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta cabs for Pune Airport transfers. AC, chauffeur-driven, family-friendly, and budget airport taxi service with online booking."
  />
  <meta
    name="keywords"
    content="Innova Crysta Airport Taxi Pune, Pune Airport Innova Crysta Cab Booking, AC Innova Crysta Pune Airport Transfer, Online Booking Innova Crysta Taxi Pune Airport, Chauffeur Driven Innova Crysta Pune Airport, Family Airport Innova Crysta Taxi Pune, Airport Pickup Innova Crysta Pune, Budget Innova Crysta Airport Cab Pune, Private Innova Crysta Pune Airport Ride"
  />
  <script type="application/ld+json">
    {JSON.stringify(airportCabSchema)}
  </script>
</Helmet>
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabsforpuneairport;